import React from 'react';
import './index.css';
import App from './App';
import { installRequestFeedback } from './utils/request-feedback';

import {createRoot} from 'react-dom/client'

installRequestFeedback();

createRoot(document.getElementById('root')).render(
    <App />
);
